import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Alert } from "@mui/material";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import Transition from "./Transition";
import BeltAvatar from "../beltavatar/BeltAvatar";
import { useUpdateMemberMutation } from "../../features/members/membersApiSlice";
import { setDialog } from "../../features/dialog/dialogSlice";
import Loading from "../spinners/Loading";
import { gradArray } from "../form/fields/inputFields";

function ChangeDegreeDialog({ handleClose, member }) {
  const dispatch = useDispatch();

  const [newDegree, setNewDegree] = React.useState(member.degree ?? 0);

  const [updateMember, { isLoading, isError }] = useUpdateMemberMutation();
  const [errorMessage, setErrorMessage] = React.useState("");

  const getErrorMessage = (error) => {
    const status = error?.status ?? error?.originalStatus;
    if (status === 401 || status === 403) {
      return "Keine Berechtigung: Gürtelgrad darf von Ihrem Konto nicht geändert werden.";
    }
    return (
      error?.data?.message ||
      "Es gab ein Problem beim Ändern des Gürtels. Bitte probieren Sie es erneut."
    );
  };

  const handleChange = (event) => {
    setNewDegree(event.target.value);
  };

  const handleNewDegree = async () => {
    if (member.degree !== newDegree) {
      let newMemberData = {
        ...member,
        degree: newDegree,
      };
      try {
        setErrorMessage("");
        await updateMember({
          ...newMemberData,
          id: newMemberData._id,
        }).unwrap();
        dispatch(
          setDialog({
            title: "Gürtelgrad wurde erfolgreich geändert!",
            type: "SUCCESS",
            data: {
              successText: "Gürtelgrad wurde erfolgreich geändert!",
              refetchOnClose: false,
            },
          }),
        );
      } catch (error) {
        console.log("error :>> ", error);
        setErrorMessage(getErrorMessage(error));
      }
    } else {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog
        open
        TransitionComponent={Transition}
        keepMounted
        onClose={isLoading ? null : () => handleClose()} // Close when click oustside the dialog
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Gürtelgrad ändern
            <Button disabled={isLoading} onClick={handleClose} color="inherit">
              <Icon width="40" icon="icon-park-solid:close-one" />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          {isLoading && (
            <div style={{ padding: 220 }}>
              <Loading />
            </div>
          )}
          {(isError || errorMessage) && (
            <Alert severity="error">
              {errorMessage ||
                "Es gab ein Problem beim Ändern des Gürtels. Bitte probieren Sie es erneut."}
            </Alert>
          )}

          {!isLoading && !isError && (
            <Grid container justify="center" direction="column">
              <Grid item xs={12}>
                <Box sx={{ minWidth: 120, mt: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel id="degree-select-label">Gürtelgrad</InputLabel>
                    <Select
                      labelId="degree-select-label"
                      id="degree-select"
                      value={newDegree}
                      label="Gürtelgrad"
                      onChange={handleChange}
                    >
                      {gradArray.map((item) => (
                        <MenuItem key={item.value + "-key"} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid sx={{ m: 3 }} alignContent={"center"} item xs={12}>
                <BeltAvatar beltNumber={newDegree} size="medium" />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button disabled={isLoading} onClick={handleClose}>
            Abbrechen
          </Button>
          <Button
            disabled={isLoading}
            variant="contained"
            color="primary"
            onClick={handleNewDegree}
          >
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ChangeDegreeDialog.propTypes = {
  handleClose: PropTypes.func,
  member: PropTypes.object,
};

export default ChangeDegreeDialog;
